import { OnOrder } from 'services/api/pay';
import OrderedDeal from './OrderedDeal';

export interface ServiceOverviewProps {
  onOrder: OnOrder;
}

const ServiceOverview = (props: ServiceOverviewProps) => {
  const { onOrder } = props;

  return (
    <div>
      <OrderedDeal onOrder={onOrder} />
    </div>
  );
};

export default ServiceOverview;
